import React from "react";
import ArticlePost from "../../components/BlogPreview/BlogPost";
import Footer from "../../components/Footer/Footer";
import { useParams } from "react-router-dom";

const ArticlePage = () => {
  const { slug } = useParams();
  return (
    <main>
      <ArticlePost file={process.env.PUBLIC_URL + `/posts/${slug}/post.md`} />
      <Footer />
    </main>
  );
};

export default ArticlePage;
